/**
 * Resolves the stage's error notice — the banner shown when a run failed
 * while a rendered page is on stage. Empty-stage failures use the host-owned
 * retry treatment in `StagePage`; raw model text never becomes that failure
 * treatment.
 */
import type { StageView } from './stage-view.ts';

export interface ErrorNoticeInput {
  viewKind: StageView['kind'];
  lastRunError: { responseId: string; message: string } | null;
  liveTurn: { responseId: string | undefined; responseText: string } | undefined;
}

export function resolveErrorNotice(input: ErrorNoticeInput): string | null {
  if (!input.lastRunError) {
    return null;
  }
  if (
    input.viewKind === 'text' ||
    input.viewKind === 'loading' ||
    input.viewKind === 'unavailable'
  ) {
    return null;
  }
  if (input.liveTurn?.responseId !== input.lastRunError.responseId) {
    return null;
  }
  return input.lastRunError.message;
}
